export const getPromoOnboardDismissed = state =>
  state.search.promoOnboardDismissed;
